import { MaterialRequestsTable } from "./MaterialRequestsTable";
import { InventoryStats } from "./InventoryStats";
import { InventoryControlPanel } from "./InventoryControlPanel";
import { Plus } from "lucide-react";

export const RequestsView = ({
  filteredRequests,
  projects,
  allAggregatedItems,
  user,
  setSelReq,
  setDispatchReq,
  handleDeliver,
  ownerAction,
  search,
  setSearch,
  filters,
  setFilters,
  requestStatusOptions,
  dynamicSettings,
  onAddItems,
  onCreateRequest,
  onExport
}) => {
  return (
    <div className="space-y-6 animate-in fade-in duration-500">
      <InventoryStats
        activeTab={filteredRequests?.[0]?.serviceType || "Generic"}
        viewMode="requests"
        subTab="items"
        isExpanded={false}
        setIsExpanded={() => {}}
        requests={filteredRequests}
        inventory={[]}
        sales={[]}
        returns={[]}
        purchaseReturns={[]}
      />
      <InventoryControlPanel
        activeTab={filteredRequests?.[0]?.serviceType || "Generic"}
        search={search}
        setSearch={setSearch}
        searchPlaceholder="Search by Customer Name..."
        filters={filters}
        setFilters={setFilters}
        dynamicSettings={dynamicSettings}
        projects={projects}
        showStatusFilter={true}
        customStatusOptions={requestStatusOptions || [
          { value: 'pending', label: 'Pending' },
          { value: 'pending_store', label: 'Pending Store' },
          { value: 'pending_owner_approval', label: 'Awaiting Owner Approval' },
          { value: 'owner_approved', label: 'Owner Approved' },
          { value: 'approved', label: 'Approved' },
          { value: 'partially_delivered', label: 'Partially Delivered' },
          { value: 'dispatched', label: 'Dispatched' },
          { value: 'in_transit', label: 'In Transit' },
          { value: 'delivered', label: 'Delivered' },
          { value: 'rejected', label: 'Rejected' },
          { value: 'fulfilled', label: 'Fulfilled' }
        ]}
        statusPlaceholder="All Statuses"
        showCategoryFilter={false}
        showVendorFilter={false}
        showCustomerFilter={false}
        onExport={onExport}
      />
      <MaterialRequestsTable
        allAggregatedItems={allAggregatedItems}
        activeTab={null}
        materialRequests={filteredRequests}
        projects={projects}
        user={user}
        onViewRequest={setSelReq}
        onDeliver={setDispatchReq}
        onMarkAsDelivered={handleDeliver}
        onOwnerAction={ownerAction}
        onAddItems={onAddItems}
        isInventoryModule={true}
      />
    </div>
  );
};

